import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import Main from './Main';

export default function Index({ onClose, onCloseByTimeout, welcomeMessage }) {
  return (
    <StrictMode>
      <Main
        onClose={onClose}
        onCloseByTimeout={onCloseByTimeout}
        welcomeMessage={welcomeMessage}
      />
    </StrictMode>
  );
}

Index.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCloseByTimeout: PropTypes.func.isRequired,
  welcomeMessage: PropTypes.string,
};

Index.defaultProps = {
  welcomeMessage: '',
};
